import { createRouter, createWebHistory } from 'vue-router';
import routes from './routes';
import { useAuthStore } from '@/store/auth';



const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {

  const auth = useAuthStore()
  // Ensure roles is always an array for checking
  // If undefined/null -> empty array
  // If string (single role) -> wrap in array
  // If array -> use as is
  let userRoles = auth._roles || [];
  if (typeof userRoles === 'string') {
      userRoles = [userRoles];
  }

  if (to.meta.requiresAuth && !auth._token) {
    return next('/login')
  }

  if (to.meta.roles && to.meta.roles.length > 0) {
    const hasRole = userRoles.some(role => to.meta.roles?.includes(role))
    if (!hasRole) {
      // Maybe redirect to 403 or home? For now login seems safe fallback but might loop if logged in.
      // Better: if logged in but no access, maybe just next() but let view handle?
      // Or 403 page.
      // But adhering to current logic:
      return next('/login') 
    }
  }

  next()
})

export default router;